const CSV_SEPARATOR: string = ",";

export const readCsv = (raw: string | null): string[] => {
  if (!raw) return [];

  return raw
    .split(CSV_SEPARATOR)
    .map((value: string): string => value.trim())
    .filter((value: string): boolean => value.length > 0);
};

export const writeCsv = (values: readonly string[]): string =>
  values.join(CSV_SEPARATOR);

export const readInt = (raw: string | null, fallback: number): number => {
  const parsed: number = Number(raw);

  if (!raw || !Number.isInteger(parsed) || parsed < 1) return fallback;

  return parsed;
};

export const readOneOf = <TValue extends string>(
  raw: string | null,
  allowed: readonly TValue[],
): TValue | undefined => {
  const match: TValue | undefined = allowed.find(
    (value: TValue): boolean => value === raw,
  );

  return match;
};

export const readSubsetOf = <TValue extends string>(
  raw: string | null,
  allowed: readonly TValue[],
): TValue[] => {
  const requested: string[] = readCsv(raw);

  return allowed.filter((value: TValue): boolean =>
    requested.includes(value),
  );
};

export const applyToSearchParams = (
  current: URLSearchParams,
  updates: Readonly<Record<string, string | null>>,
): URLSearchParams => {
  const next: URLSearchParams = new URLSearchParams(current);

  Object.entries(updates).forEach(([key, value]: [string, string | null]) => {
    if (value === null || value === "") {
      next.delete(key);
      return;
    }

    next.set(key, value);
  });

  return next;
};
